// extracted by mini-css-extract-plugin
export default {"divider":"_1GSLFUee55k262HUsqxFq_"};